import {
  Box,
  Typography,
  IconButton,
  Collapse,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

export function AnuncioDetalhesVeiculos({
  children,
  open,
  onToggle,
}: {
  children: React.ReactNode;
  open: boolean;
  onToggle: () => void;
}) {;
  return (
    <Box mt={2}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={0.4}
        bgcolor="rgba(254, 102, 0, 0.12)"
        color="primary.main"
        borderRadius={2}
        sx={{ cursor: "pointer" }}
        onClick={onToggle}
      >
        <Typography fontSize="0.75rem" fontWeight={700}>
          Ver detalhes dos veículos
        </Typography>
        <IconButton size="small">
          <ExpandMoreIcon
            sx={{
              color: "primary.main",
              transform: open ? "rotate(180deg)" : "none",
              transition: "transform .3s",
            }}
          />
        </IconButton>
      </Box>

      <Collapse in={open}>{children}</Collapse>
    </Box>
  );
}
